interface PuceCodeProps {
  children: string;
}

/** A code of Tahiti in a small grey pill: the type of an addition, the state of an affirmation. */
export function PuceCode({ children }: PuceCodeProps) {
  return (
    <span className="inline-flex h-[22px] shrink-0 items-center whitespace-nowrap rounded-full bg-gray-100 px-2 font-semibold text-gray-800 text-badge leading-none">
      {children}
    </span>
  );
}
